export const SELECTED_CLIENT_ID_CHANGED_EVENT = 'selectedClientIdChanged'

/**
 * Utility class for managing selectedClientId in localStorage
 */
export class SelectedClientIdStorage {
  private static readonly STORAGE_KEY = 'selectedClientId'

  /**
   * Get the selected client ID from localStorage
   */
  static get(): string | null {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(this.STORAGE_KEY)
  }

  /**
   * Set the selected client ID in localStorage
   */
  static set(clientId: string): void {
    if (typeof window === 'undefined') return
    localStorage.setItem(this.STORAGE_KEY, clientId)
  }

  /**
   * Remove the selected client ID from localStorage
   */
  static remove(): void {
    if (typeof window === 'undefined') return
    localStorage.removeItem(this.STORAGE_KEY)
  }

  /**
   * Check if a client ID is currently selected
   */
  static hasSelected(): boolean {
    return this.get() !== null
  }

  /**
   * Clear all selected client ID data
   */
  static clear(): void {
    this.remove()
  }
}

export function emitSelectedClientIdChanged(clientId: string | null): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(SELECTED_CLIENT_ID_CHANGED_EVENT, { detail: clientId }))
}

// Convenience functions for common operations
export const getSelectedClientId = () => SelectedClientIdStorage.get()
export const setSelectedClientId = (clientId: string) => SelectedClientIdStorage.set(clientId)
export const removeSelectedClientId = () => SelectedClientIdStorage.remove()
export const hasSelectedClientId = () => SelectedClientIdStorage.hasSelected()
